$(document).ready(function () {
  //Take to shooping cart
  if ($('#salesBanner').length) {
    let salesBannerHeight = Math.floor($('#salesBanner').height());

    if ($('#salesBanner').hasClass('isSticky')) {
      $('#salesBanner, .btn:not(.cta):not(.play):not(.purchase-popover__cta):not(.modal-body__cta), .bannerSpecial, #promoBanner').on('click', function (event) {
        if ($("#topSection").length) {
          $('html, body').animate({
            scrollTop: $("#topSection").offset().top - salesBannerHeight
          }, 1000);
        } else if ($('#productBanner').length) {
          $('html, body').animate({
            scrollTop: $("#productBanner").offset().top - salesBannerHeight
          }, 1000);
        }
      });
    } else {
      $('#salesBanner, .btn:not(.cta):not(.play):not(.purchase-popover__cta):not(.modal-body__cta), .bannerSpecial, #promoBanner').on('click', function (event) {
        if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
          $('html, body').animate({
            scrollTop: $("#promoBannerAnchor").offset().top
          }, 1000);
        } else if ($("#topSection").length) {
          $('html, body').animate({
            scrollTop: $("#topSection").offset().top
          }, 1000);
        } else if ($('#productBanner').length) {
          $('html, body').animate({
            scrollTop: $("#productBanner").offset().top
          }, 1000);
        }
      });
    }

  } else {
    $('.btn:not(.cta):not(.play):not(.purchase-popover__cta):not(.modal-body__cta), .bannerSpecial, #promoBanner').on('click', function (event) {
      if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
        $('html, body').animate({
          scrollTop: $("#promoBannerAnchor").offset().top
        }, 1000);
      } else {
        if ($("#topSection").length && $(window).width() <= 1024) {
          $('html, body').animate({
            scrollTop: $("#topSection").offset().top
          }, 1000);
        } else if ($("#productBanner").length && $(window).width() <= 1024) {
          $('html, body').animate({
            scrollTop: $("#productBanner").offset().top
          }, 1000);
        } else {
          $('html, body').animate({
            scrollTop: $("#orderNow").offset().top
          }, 1000);
        }
      }
    });
  }

  /**
   * component: cartToggleCartSections
   * controls which cart version should display
   */

  let cartWrapper = $('#orderNow'),
      carts = cartWrapper.children('div'),
      orderMobileArr = [0, 1],
      orderDesktopArr = [1, 0];

  /**
  * Reorder of carts within #orderNow for TCR to work
  * 
  * @param {*} wrapper - cart component section
  * @param {*} items - children
  * @param {*} orderArr - order of appearance of the children 
  */
  function cartsReorder(wrapper, items, orderArr) {
    for (let i = 0; i < orderArr.length; i++) {
      for (let j = 0; j < orderArr.length; j++) {
        if (i == orderArr[j]) {
          wrapper.append(items[j]);
          break;
        }
      }
    }
  }

  /**
  * Reorder carts (mobile and desktop) and change modifier class of cart section
  */
  function displayCartSectionsDesktop() {
    if ($('#orderNow').hasClass('cart--toggle')) {
      $('#orderNow').removeClass('cart--toggle').addClass('cart--sections');

      cartsReorder(cartWrapper, carts, orderDesktopArr);

      $('.cart-sections .cart__product.active').trigger('click');
    }
  }

  function displayCartToggleMobile() {
    if ($('#orderNow').hasClass('cart--sections')) {
      $('#orderNow').removeClass('cart--sections').addClass('cart--toggle');

      cartsReorder(cartWrapper, carts, orderMobileArr);

      $('.cart-toggle .cart__product.active').trigger('click');
    }
  }

  /**
  * Load based on screen size or resize
  */
  if ($(window).width() > 1024) {
    displayCartSectionsDesktop();

  } else {
    displayCartToggleMobile();
  }

  $(window).resize(function () {
    let cart = $('#orderNow');

    if (this.resizeWindow) {
      clearTimeout(this.resizeWindow);
    }

    this.resizeWindow = setTimeout(function () {
      if ($(window).width() > 1024 && cart.hasClass('cart--toggle')) {
        displayCartSectionsDesktop();

      } else if ($(window).width() <= 1024 && cart.hasClass('cart--sections')) {
        displayCartToggleMobile();
      }
    }, 500);
  });

  /**
   * Cart Toggle (Mobile) and Cart Sections (desktop)
   * ************************************************
   * Add cookies on 1st cartCTA click to control if to open #purchaseModal popup or popover
   */
  const cartCTA = $('#cartCTA[data-toggle]');

  if (purchaseModalOpenOnce == true || popoverOpenOnce == true) {
    if (!$.cookie('cartCTAClicked')) {
      $(cartCTA).on('click', function () {       
          $.cookie("cartCTAClicked", 1); //- expire per session
  
          setTimeout(function () {
            cartCTA.attr('data-toggle', 'false');
  
          }, 500);
        
      });
    } else {
      cartCTA.attr('data-toggle', 'false');
      
    }
  }

  /**
   * Handle popover 
   */
  const popover = $('.purchase-popover');

  $('#cartCTA[data-toggle="popover"]').on('click', function (e) {
    if ($('[data-toggle="popover"]').length > 1) {
      e.preventDefault();

      popover.toggleClass('purchase-popover--show');

      if(popoverOpenOnce == true && popover.parent('.cart-sections')) {
        $(this).prev('.purchase-popover').addClass('purchase-popover--once');
      }
      
      e.stopPropagation();
    }
  });
 
  $('.purchase-popover__cta').on('click', function() {
    if(popoverOpenOnce == true && popover.hasClass('purchase-popover--once')) {
      popover.removeClass('purchase-popover--once');
    }
  })
 
  if(showModal == true && $('#cartCTA[data-toggle="popover"]')) {
    $('#popoverSubscribeButton').on('click', function () {
      popover.toggleClass('purchase-popover--show');
    });
  }

  /**
   * Cart Toggle (Mobile)
   * ********************
   * 
   * Active Product Toggle
   */
  function activeProductToggle() {
    let thisProduct = $(this);

    let amount = thisProduct.attr('data-units'),
        price = 'data-price',
        link = 'data-link',
        ship = 'data-shipping',
        retail = 'data-retail',
        sale = '',
        subscribeAttr = $('.cart-toggle .purchase-box__checkbox').attr('data-checkbox');

    let selectedProductAmount = $('.cart-toggle #cartToggle').find(`[data-units='${amount}']`);

    /**
     * Under Morning Sale 
     */
    if ($('body').hasClass('show-promoBanner')) {
      sale = '-sale';
    }

    /**
     * Product buttons states
     */
    $('.cart-toggle .cart__product').removeClass('active');
    selectedProductAmount.addClass('active');

    /**
     * Controls Product Images based on selection
     */
    $('#orderNow').removeClass(function (index, className) {
      return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
    }).addClass('cart--unit' + amount);

    if ($('#toggleMode').length) {
      /**
       * Specific vars for Subscription Mode
       */
      let subscriptionMode = {
        wrap: $('#subscribeSection'),
        prod: $('#subscribeSection').find(`[data-units='${amount}']`),
        param: $('#subscribeSection').find('.btn.cta').attr('data-param'),
        modalCta: $('#subscribeButton'),
        purchasePriceModal: $('#purchaseModal').find('.amount--continuity')
      }

      /**
       * Specific vars for Normal Mode
       */
      let regularMode = {
        wrap: $('#regularSection'),
        prod: $('#regularSection').find(`[data-units='${amount}']`),
        param: $('#regularSection').find('.btn.cta').attr('data-param'),
        modalCta: $('#regularButton'),
        purchasePriceModal: $('#purchaseModal').find('.amount--regular')
      }

      const carts = [subscriptionMode, regularMode];

      for (const cart of carts) {
        let savingsVal = cart['prod'].attr(retail) - cart['prod'].attr(price + sale);
        let pricePerUnit = parseFloat(cart['prod'].attr(price + sale) / amount).toFixed(2);

        cart['wrap'].find('.price__value').html('$' + cart['prod'].attr(price + sale));
        cart['wrap'].find('.price-per-unit__value').html('$' + pricePerUnit);
        cart['wrap'].find('.retail__value').html('$' + cart['prod'].attr(retail));
        cart['wrap'].find('.saving__value').html('$' + parseFloat(savingsVal).toFixed(2));

        cart['wrap'].find('.shipping__value').html(cart['prod'].attr(ship));

        cart['wrap'].find('.btn').attr('href', (cart['prod'].attr(link + sale) + cart['param']));

        //- handle Modal popup
        cart['purchasePriceModal'].find('.amount__value').html('$' + cart['prod'].attr(price + sale));
        cart['modalCta'].attr('href', (cart['prod'].attr(link + sale) + cart['param']));
      }
    }

    if ($('#unToggleMode').length) {
      //- handle Modal popup and popover
      let priceModalRegular = $('#purchaseModal').find('.amount--regular'),
          modalCtaRegular = $('#regularButton'),
          popoverCtaRegular = $('#popoverRegularButton'),
          priceModalContinuity = $('#purchaseModal').find('.amount--continuity'),
          modalCtaSubscribe = $('#subscribeButton'),
          popoverCtaSubscribe = $('#popoverSubscribeButton'),
          priceSubscribe = 'data-subscribe-price',
          linkRegular = 'data-link',
          linkSubscribe = 'data-subscribe-link';

      //- setLinks and prices
      if (subscribeAttr == 'true') {
        link = 'data-subscribe-link',
        price = 'data-subscribe-price';
      }

      let savingsVal = thisProduct.attr(retail) - thisProduct.attr(price + sale);

      $('#unToggleMode .retail__value').html('$' + thisProduct.attr(retail));
      $('#unToggleMode .price__value').html('$' + thisProduct.attr(price + sale));
      $('#unToggleMode .saving__value').html('$' + parseFloat(savingsVal).toFixed(2));

      let param = $('#unToggleMode .cta').attr('data-param');
      $('#unToggleMode .cta').attr('href', thisProduct.attr(link + sale) + param);

      //- handle Regular Modal button links is unsubscribe
      if ($('#cartToggle').attr('data-check') === 'un-subscribe') {

        priceModalRegular.find('.amount__value').html('$' + thisProduct.attr(price + sale));
        priceModalContinuity.find('.amount__value').html('$' + thisProduct.attr(priceSubscribe + sale));

        modalCtaRegular.attr('href', thisProduct.attr(linkRegular + sale) + param);
        modalCtaSubscribe.attr('href', thisProduct.attr(linkSubscribe + sale) + param);

        popoverCtaRegular.attr('href', thisProduct.attr(linkRegular + sale) + param);
        popoverCtaSubscribe.attr('href', thisProduct.attr(linkSubscribe + sale) + param);
      } else {
        cartCTA.attr('data-toggle', 'false');
      }
    }
  };

  /**
   * Subscription Option UI and Behaviour for cartToggle showContinuityWithinRegularSection = 'false'
   */
  function cartToggleSubscriptionUI() {
    let alternativeContentValue;

    $('.subscribe-wrap').toggleClass('active');

    if ($('#cartToggle').attr('data-check') === 'un-subscribe') {
      alternativeContentValue = '';

      $('#cartToggle').attr('data-check', 'subscribe');
      $('body').addClass('show-promoBanner--club');

    } else {
      alternativeContentValue = $('#alternativeContent').attr('data-alt-content');

      $('#cartToggle').attr('data-check', 'un-subscribe');
      $('body').removeClass('show-promoBanner--club');

    }

    $('#alternativeContent').html(' ' + alternativeContentValue);

    if ($('#salesBanner').length) {
      let salesBannerHeight = Math.floor($('#salesBanner').height());
      if ($('#salesBanner').hasClass('isSticky')) {
        $('html, body').animate({
          scrollTop: $("#orderNow").offset().top - salesBannerHeight
        }, 1000);
      } else {
        $('html, body').animate({
          scrollTop: $("#orderNow").offset().top
        }, 1000);
      }
    } else if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
      $('html, body').animate({
        scrollTop: $("#promoBannerAnchor").offset().top
      }, 1000);
    } else if ($("#topSection").length) {
      $('html, body').animate({
        scrollTop: $("#topSection").offset().top
      }, 1000);
    } else if ($("#productBanner").length) {
      $('html, body').animate({
        scrollTop: $("#productBanner").offset().top
      }, 1000);
    } else {
      $('html, body').animate({
        scrollTop: $("#orderNow").offset().top
      }, 1000);
    }

    //- reset subscription disclaimer checkbox
    if ($('.cart-toggle .purchase-box__label').hasClass('checked') && !$('#cartCTASubscribe').hasClass('disabled')) {
      $('.cart-toggle .purchase-box__label').removeClass('checked');
      $('#cartCTASubscribe').addClass('disabled');
      $('.cart-toggle .purchase-box__checkbox').attr('data-checkbox', false);
    }
  }

  /**
   * Disclaimer Checkbox and Button disabled
   */
  function cartToggleCheckbox(e) {
    e.preventDefault();

    if (!$(this).hasClass('checked')) {
      $(this).addClass('checked');
      $('.cart-toggle .purchase-box__checkbox').attr('data-checkbox', true);

      if ($('#toggleMode').length) {
        $('#cartCTASubscribe').removeClass('disabled');
      }

      if ($('#unToggleMode').length) {
        $('#cartToggle').attr('data-check', 'subscribe');

        if ($('body').hasClass('show-promoBanner')) {
          $('body').addClass('show-promoBanner--club');
        }
      }

    } else {
      $(this).removeClass('checked');
      $('.cart-toggle .purchase-box__checkbox').attr('data-checkbox', false);

      if ($('#toggleMode').length) {
        $('#cartCTASubscribe').addClass('disabled');
      }

      if ($('#unToggleMode').length) {
        $('#cartToggle').attr('data-check', 'un-subscribe');

        if ($('body').hasClass('show-promoBanner')) {
          $('body').removeClass('show-promoBanner--club');
        }
      }
    }

    $('#unToggleMode .cart__product.active').trigger('click');
  }

  function setPopoverLinksToggle() {
    let sale = '',

        popoverCtaRegular = $('#popoverRegularButton'),
        popoverCtaSubscribe = $('#popoverSubscribeButton'),
        linkRegular = $('.cart-toggle #cartCTA').attr('href'),
        linkSubscribe = $('.cart-toggle #cartCTASubscribe').attr('href');

    /**
     * Under Morning Sale 
     */
    if ($('body').hasClass('show-promoBanner')) {
      sale = '-sale';
    }

    //- handle Popover button links
    popoverCtaRegular.attr('href', linkRegular + sale);
    popoverCtaSubscribe.attr('href', linkSubscribe + sale);
  }

  $('.cart-toggle .cart__product').on('click', activeProductToggle);
  $('.cart-toggle .cart__product').on('click', setPopoverLinksToggle);
  $('.subscribe-wrap__option').on('click', cartToggleSubscriptionUI);
  $('.cart-toggle .cart__product.active').trigger('click');
  $('.cart-toggle .purchase-box__label').on('click', cartToggleCheckbox);

  /**
   * Cart Sections (desktop)
   * ***********************
   * 
   * Disclaimer Checkbox and Button disabled
   */
  function cartSectionsCheckbox(e) {
    e.preventDefault();

    if (!$(this).hasClass('checked')) {
      $(this).addClass('checked');
      $('.cart-sections .purchase-box__checkbox').attr('data-checkbox', true);
      $('body').addClass('show-promoBanner--club');

      if (purchaseModalOpenOnce == true || popoverOpenOnce == true) {
        if (!$.cookie('cartCTAClicked')) {
          $('#cartCTA').attr('data-toggle', 'false');
        }
      }

    } else {
      $(this).removeClass('checked');
      $('.cart-sections .purchase-box__checkbox').attr('data-checkbox', false);
      $('body').removeClass('show-promoBanner--club');

      if (!$.cookie('cartCTAClicked')) {
        if (showModal == true && showPopover != true) {
          $('#cartCTA').attr('data-toggle', 'modal');

        } else if (showPopover == true) {
          $('#cartCTA').attr('data-toggle', 'popover');

        }
      }
    }

    $('.cart-sections .cart__product.active').trigger('click');
  }

  /**
  * Data Attributes list
  */
  // Set Prices
  function setLinks() {
    let thisProduct = $(this),
        link,
        sale = '',
        subscribeAttr = $('.cart-sections .purchase-box__checkbox').attr('data-checkbox'),

        //- Regular modal popup
        modalCtaRegular = $('#regularButton'),
        modalCtaSubscribe = $('#subscribeButton'),
        popoverCtaRegular = $('#popoverRegularButton'),
        popoverCtaSubscribe = $('#popoverSubscribeButton'),
        linkRegular = 'data-link',
        linkSubscribe = 'data-subscribe-link';

    if (subscribeAttr == 'true') {
      link = 'data-subscribe-link';
    } else {
      link = 'data-link';
    }

    /**
     * Under Morning Sale 
     */
    if ($('body').hasClass('show-promoBanner')) {
      sale = '-sale';
    }

    let param = $('.cart-sections .cta').attr('data-param');
    $('.cart-sections .cta').attr('href', thisProduct.attr(link + sale) + param);

    //- handle Regular Modal button links
    modalCtaRegular.attr('href', thisProduct.attr(linkRegular + sale) + param);
    modalCtaSubscribe.attr('href', thisProduct.attr(linkSubscribe + sale) + param);

    //- handle Popover button links
    popoverCtaRegular.attr('href', thisProduct.attr(linkRegular + sale) + param);
    popoverCtaSubscribe.attr('href', thisProduct.attr(linkSubscribe + sale) + param);
  }

  // Calculate Instant and Member Savings based on retailVal and price
  function calcSavings(subscribeAttr, thisProduct, retailVal) {
    let sale = '';

    /**
     * Under Morning Sale 
     */
    if ($('body').hasClass('show-promoBanner')) {
      sale = '-sale';
    }

    let price = thisProduct.attr('data-price' + sale),
        priceSubs = thisProduct.attr('data-subscribe-price' + sale);

    //- Calculate Savings and Member Savings based on data-retail, data-price and data-subscribe-price values
    let saving = Number(retailVal - price).toFixed(2),
        savingSubs = Number(retailVal - priceSubs).toFixed(2),
        memberSaving = Number(savingSubs - saving).toFixed(2);

    if (subscribeAttr == 'true') {
      $('.cart-sections .saving__value').html('$' + savingSubs);
      $('.cart-sections .member__value').html('$' + memberSaving);

    } else {
      $('.cart-sections .saving__value').html('$' + saving);
    }
  }

  // Set Active Product
  function activeProductSections() {
    let thisProduct = $(this),
        amount = thisProduct.attr('data-units');
    let subscribeAttr = $('.cart-sections .purchase-box__checkbox').attr('data-checkbox');

    //- handle Modal popup
    let priceModalRegular = $('#purchaseModal').find('.amount--regular'),
        priceModalContinuity = $('#purchaseModal').find('.amount--continuity'),
        priceSubscribe = 'data-subscribe-price';

    const retail = thisProduct.attr('data-retail');

    calcSavings(subscribeAttr, thisProduct, retail);

    let price, shipping, sale = '';

    $('#orderNow').removeClass(function (index, className) {
      return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
    }).addClass('cart--unit' + amount);

    if (subscribeAttr == 'true') {
      price = 'data-subscribe-price';
      shipping = 'data-subscribe-shipping';

      $('.cart-sections .summary').addClass('summary--subscribe');

    } else {
      price = 'data-price';
      shipping = 'data-shipping';

      $('.cart-sections .summary').removeClass('summary--subscribe');
    }

    /**
     * Under Morning Sale 
     */
    if ($('body').hasClass('show-promoBanner')) {
      sale = '-sale';
    }

    let pricePerUnit = parseFloat(thisProduct.attr(price + sale) / amount).toFixed(2);

    $('.cart-sections .cart__product').removeClass('active');
    thisProduct.addClass('active');

    $('.cart-sections .price-per-unit__value').html('$' + pricePerUnit);
    $('.cart-sections .price__value').html('$' + thisProduct.attr(price + sale));
    $('.cart-sections .retail__value').html('$' + retail);
    $('.cart-sections .shipping__value').html(thisProduct.attr(shipping));

    priceModalRegular.find('.amount__value').html('$' + thisProduct.attr(price + sale));
    priceModalContinuity.find('.amount__value').html('$' + thisProduct.attr(priceSubscribe + sale));

    // setLinks();
  };

  $('.cart-sections .cart__product').on('click', setLinks);
  $('.cart-sections .cart__product').on('click', activeProductSections);
  $('.cart-sections .cart__product.active').trigger('click');
  $('.cart-sections .purchase-box__label').on('click', cartSectionsCheckbox);

  //- Other Sections
  $('.tabs .items').slick({
    speed: 300,
    centerMode: false,
    adaptiveHeight: true,
    dots: true,
    appendDots: $(".tabs .nav"),
    customPaging: function (slick, index) {
      var title = slick.$slides.eq(index).find('.item').attr('data-title');
      return ' <div class="item">' + title + '</div>'
    }
  });

  if ($('#reviewsComment').length) {
    $('#reviewsComment').slick({
      slidesToShow: 1,
      arrows: true,
      dots: true,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: false
    });
  }

  if ($('#reviewsVideo').length) {
    $('#reviewsVideo').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: true,
      dots: true,
      speed: 300,
      responsive: [
        {
          breakpoint: 890,
          settings: {
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '40px'
          }
        },
        {
          breakpoint: 520,
          settings: {
            infinite: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '30px'
          }
        },
        {
          breakpoint: 321,
          settings: {
            infinite: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '15px'
          }
        }
      ]
    });
  }

  /**
   * Handle Video instances Play/Pause
   */
  // Create array for player IDs
  let players = [];

  // Determine the available player IDs
  for (let i = 0; i < Object.keys(videojs.players).length; i++) {
    // Assign the player name to setPlayer
    var setPlayer = Object.keys(videojs.players)[i];

    // Define the ready event for the player
    videojs.getPlayer(setPlayer).ready(function () {
      // Assign this player to a variable
      let myPlayer = this;

      // Assign and event listener for play event
      myPlayer.on("play", onPlay);

      // Push the player to the players array
      players.push(myPlayer);
    });
  }

  // Handle all players' play event 
  function onPlay(e) {
    // Determine which player the event is coming from
    var id = e.target.id;

    // Loop through the array of players
    for (let x = 0; x < players.length; x++) {
      // Get the player(s) that did not trigger the play event
      if (players[x].id() != id) {
        // Pause the other player(s)
        videojs(players[x].id()).pause();
      }
    }
  }

  //- Set current Year to footer Copyright
  let thisDate = new Date();
  $('#year').html(thisDate.getFullYear());
});
